<p-toast></p-toast>

<p-sidebar
  [(visible)]="open"
  position="right"
  (onHide)="onClose()"
  [style]="{ width: '36em' }"
>
  <ng-template pTemplate>
    <div class="surface-card p-4 shadow-2 border-round">
      <div class="font-medium text-2xl text-700 mb-3">{{ settings.title }}</div>
      <div class="text-500 mb-5">
        Revisar la información del producto, antes de agregarlo al carrito.
      </div>
      <form [formGroup]="fg">
        <ul class="list-none p-0 m-0">
          <li
            *ngFor="let item of itemStock; let i = index"
            class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap"
          >
            <div class="text-500 w-2 md:w-5 font-medium">
              {{ item.label }}
            </div>
            <div
              *ngIf="
                item.label !== 'Precio de venta' &&
                item.label !== 'Margen de ganancia'
              "
              class="text-900 w-full ml-1 md:w-6 md:flex-order-0 flex-order-1"
            >
              {{ item.value }}
            </div>
            <div
              *ngIf="item.label === 'Precio de venta'"
              class="text-900 w-full ml-1 md:w-6 md:flex-order-0 flex-order-1"
            >
              {{ item.value | currency: 'PEN' }}
            </div>
            <div
              *ngIf="item.label === 'Margen de ganancia'"
              class="text-900 w-full ml-1 md:w-6 md:flex-order-0 flex-order-1"
            >
              {{ item.value | percent: '2.0-2' }}
            </div>
          </li>
          <li
            class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap"
          >
            <div class="text-500 w-2 md:w-4 font-medium">Cantidad</div>
            <div class="w-auto md:w-8 md:flex-order-0 flex-order-1">
              <p-inputNumber
                formControlName="quantityCart"
                mode="decimal"
                class="size-1"
                [showButtons]="true"
                inputId="minmax-buttons"
              >
              </p-inputNumber>
              <div
                *ngIf="
                  fg.get('quantityCart').invalid &&
                  (fg.get('quantityCart').dirty ||
                    fg.get('quantityCart').touched)
                "
                class="p-invalid"
              >
                <div *ngIf="fg.get('quantityCart').errors?.required">
                  <small class="p-error">No puede quedar vacio.</small>
                </div>
                <div *ngIf="fg.get('quantityCart').errors?.min">
                  <small class="p-error"
                    >Debe tener un valor minimo de 1.</small
                  >
                </div>
                <div *ngIf="fg.get('quantityCart').errors?.max">
                  <small class="p-error"
                    >Debe tener un valor maximo de {{ maxStock }}.</small
                  >
                </div>
              </div>
            </div>
          </li>
          <li
            class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap"
          >
            <div class="text-500 w-2 md:w-5 font-medium">Precio Parcial</div>
            <div
              class="text-900 w-full ml-1 md:w-6 md:flex-order-0 flex-order-1"
            >
              S/. {{ netPrice }}
            </div>
          </li>
          <li
            class="flex align-items-center justify-content-end flex-wrap py-3 px-2 border-top-1 surface-border flex-wrap"
          >
            <button
              pButton
              pRipple
              (click)="onClose()"
              icon="pi pi-times"
              class="p-button-text"
              pTooltip="Cancelar"
              tooltipPosition="left"
              label="No"
            ></button>
            <button
              (click)="onSubmit()"
              pButton
              pRipple
              class="p-button-text"
              icon="pi pi-check"
              [disabled]="fg.invalid"
              label="Si"
              [pTooltip]="settings.tooltip"
              tooltipPosition="left"
            ></button>
          </li>
        </ul>
      </form>
    </div>
  </ng-template>
</p-sidebar>
